module.exports = __webpack_public_path__ + "static/media/eye.d8697e40.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/eye.svg
// module id = 647
// module chunks = 0